import round from 'lodash.round';

export default (value, precision) => round(value, precision).toFixed(precision);
